// rys-specific login helpers. The code-alphabet/countdown/error helpers and the
// CODE_*/RESEND_* constants now live in @foundation-bb/foundation-auth-ui (shared,
// de-duplicated across rys + Scribia); only the rys-local localStorage key for
// remembering the last-used login email remains here.
export const EMAIL_STORAGE_KEY = 'rys_login_email';
